import { AreaKind } from "src/components/shared-components/enum/enumArea";
import { Environment } from "../../../components/shared-components/class/general-classes/environment";

/**
 * This class handle generic area kind
 */
export class Area {
  id: number;
  idParentArea: number;
  customDescription: string;
  customId: number;
  description: string;
  environmentIDs: Array<number>;
  instanceGUID: string;
  kind: AreaKind;
  orderNumber: number;
  default: boolean;

  childrenAreas: Array<Area>;
  childrenEnvironments: Array<Environment>;

  constructor(area?: any) {
    // used for assign type to instance of object
    if (area) {
      Object.assign(this, area);
    }
  }
}
